export const OAUTH_AUTHTYPE = "oauth";

export const oauthRequestFields = ({ email, name, provider, providerId } = {}) => {
  const fields = {
    provider,
    providerId,
    authtype: OAUTH_AUTHTYPE,
  };
  if (email) {
    fields.email = email;
  }
  if (name) {
    const [firstName, ...rest] = String(name).trim().split(" ");
    fields.First_Name = firstName;
    fields.Last_Name = rest.join(" ");
  }
  return fields;
};
